import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 flex-wrap">
      {items.map((item, i) => (
        <span key={item.label} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className="hover:text-secondary-700 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300" />}
        </span>
      ))}
    </nav>
  );
}